import axios from '../config/axiosConfig';

const schedulerService = {
  // Get all scheduled assessments
  getSchedules: async (params = {}) => {
    const { status, project, page = 1, limit = 20 } = params;
    const query = new URLSearchParams();
    if (status) query.append('status', status);
    if (project) query.append('project', project);
    query.append('page', page);
    query.append('limit', limit);

    const response = await axios.get(`/scheduler?${query.toString()}`);
    return response.data;
  },

  // Get calendar events
  getCalendarEvents: async (startDate, endDate, project = null) => {
    const query = new URLSearchParams();
    if (startDate) query.append('startDate', startDate);
    if (endDate) query.append('endDate', endDate);
    if (project) query.append('project', project);

    const response = await axios.get(`/scheduler/calendar?${query.toString()}`);
    return response.data;
  },

  // Get single schedule
  getSchedule: async (id) => {
    const response = await axios.get(`/scheduler/${id}`);
    return response.data;
  },

  // Create new schedule
  createSchedule: async (scheduleData) => {
    const response = await axios.post(`/scheduler`, scheduleData);
    return response.data;
  },

  // Update schedule
  updateSchedule: async (id, scheduleData) => {
    const response = await axios.put(`/scheduler/${id}`, scheduleData);
    return response.data;
  },

  // Update schedule status (pause/resume/cancel)
  updateStatus: async (id, status) => {
    const response = await axios.patch(`/scheduler/${id}/status`, { status });
    return response.data;
  },

  // Run schedule manually
  runNow: async (id) => {
    const response = await axios.post(`/scheduler/${id}/run`);
    return response.data;
  },

  // Get execution history
  getExecutionHistory: async (id, page = 1, limit = 20) => {
    const response = await axios.get(`/scheduler/${id}/executions?page=${page}&limit=${limit}`);
    return response.data;
  },

  // Delete schedule
  deleteSchedule: async (id) => {
    const response = await axios.delete(`/scheduler/${id}`);
    return response.data;
  },

  // Get stats summary
  getStats: async () => {
    const response = await axios.get(`/scheduler/stats/summary`);
    return response.data;
  },

  // Schedule types
  SCHEDULE_TYPES: [
    { value: 'once', label: 'Run Once' },
    { value: 'daily', label: 'Daily' },
    { value: 'weekly', label: 'Weekly' },
    { value: 'monthly', label: 'Monthly' }
  ],

  // Assessment types
  ASSESSMENT_TYPES: [
    { value: 'full', label: 'Full Assessment' },
    { value: 'quick', label: 'Quick Scan' },
    { value: 'custom', label: 'Custom' },
    { value: 'playbook', label: 'Playbook Execution' },
    { value: 'atomic', label: 'Atomic Tests' }
  ],

  // Days of week
  DAYS_OF_WEEK: [
    { value: 0, label: 'Sunday' },
    { value: 1, label: 'Monday' },
    { value: 2, label: 'Tuesday' },
    { value: 3, label: 'Wednesday' },
    { value: 4, label: 'Thursday' },
    { value: 5, label: 'Friday' },
    { value: 6, label: 'Saturday' }
  ]
};

export default schedulerService;
